import { PolymerElement, html } from '@polymer/polymer/polymer-element';
import '../katapult-firebase-worker/katapult-firebase-worker';

class AuthZVision extends PolymerElement {
  static get template() {
    return html``;
  }

  static get properties() {
    return {
      deviceMAC: {
        type: String
      }
    };
  }

  static get observers() {
    return ['assignDeviceToUser(deviceMAC, user)'];
  }

  ready() {
    super.ready();
    // "https://beta.katapultpro.com/home/#authZVision?MID=";
    if (window.location.hash && window.location.hash.includes('authZVision')) {
      let paramsString = window.location.hash.replace('#authZVision?', '');
      let searchParams = new URLSearchParams(paramsString);
      if (searchParams.get('MID')) {
        this.deviceMAC = searchParams.get('MID');
      }
    }
  }

  assignDeviceToUser() {
    if (this.deviceMAC && this.user && this.user.uid) {
      FirebaseWorker.ref(`devices/z-vision/${this.deviceMAC}`)
        .set(this.user.uid)
        .then(() => {
          alert(`The device has been assigned to ${this.user.email}.`);
        })
        .catch(() => {
          alert('There was an error setting up the device...');
        })
        .finally(() => {
          window.location = '/home';
        });
    }
  }
}
window.customElements.define('auth-z-vision', AuthZVision);
